import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import PromotionVariantActionsTop from './includes/actionsTop';
import PromotionVariantActionsBottom from './includes/actionsBottom';
import axios from "axios/index";
import {config} from "../../../../../../config";
import Select from 'react-select';

class PromotionVariantSideFeaturedPostComponent extends Component {
	constructor(props) {
		super(props);

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);

		this.state = {
			isLoadingPosts: false,
			posts: [],
		}
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	setSelectedPost(value) {
		api.promotions.handlePositionFieldState( 'selectedPost', value, this.props.periodKey, this.props.variantKey );
		api.promotions.handlePositionFieldState( 'title', value.post_title, this.props.periodKey, this.props.variantKey );
		api.promotions.handlePositionFieldState( 'text', value.post_excerpt, this.props.periodKey, this.props.variantKey );
		api.promotions.handlePositionFieldState( 'url', value.permalink, this.props.periodKey, this.props.variantKey );
	}

	getPosts(input, callback) {
		let cancel;

		if ( input.length < 4 ) {
			return;
		}

		return axios.get(config.postSearch.url + '?s=' + input, )
			.then( ( response ) => {
				return new Promise((resolve, reject) => {
					let i = 0;
					let options = [];

					if (response.data.length > 0) {
						response.data.map((item) => {

							let obj = {
								ID: item.ID,
								post_title: item.post_title
							};

							this.setState({
								...this.state,
								posts: [
									...this.state.posts,
									item
								]
							});

							options.push(obj);

							if (options.length === response.data.length) {
								resolve(options);
							}
						})
					} else {
						resolve(options);
					}


				}).then(options => {
					return {
						options: options
					};

				})
			})
	}

	render() {
		const variant = this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey];

        return (
			<div className={undefined === variant.active || true === variant.active ? 'medium-12 cell promotion__variation' : 'medium-12 cell promotion__variation promotion__variation--inactive' }>
				<PromotionVariantActionsTop handleActive={this.props.handleActive} removeVariation={this.props.removeVariation} periodKey={this.props.periodKey} variantKey={this.props.variantKey} />
				<div className="grid-x grid-margin-y grid-padding-x grid-margin-x">
					<div className="medium-6 cell">
						<label>
							Selecteer artikel
							<Select.Async
								valueKey="ID"
								labelKey="post_title"
								loadOptions={this.getPosts.bind(this)}
								value={this.props.promotion.periods[ this.props.periodKey].variants[ this.props.variantKey ].selectedPost}
								onChange={this.setSelectedPost.bind(this)}
								isLoading={this.state.isLoadingPosts}
							/>
						</label>
					</div>
					<div className="medium-12 cell">
						<label>
							Titel
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].title}
								id={'sidefeaturedpost-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-title' }
								fullWidth={true}
								name="title"
							/>
						</label>
					</div>
					<div className="medium-12 cell">
						<label>
							Tekst
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].text}
								id={'sidefeaturedpost-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-text' }
								fullWidth={true}
								name="text"
								multiLine={true}
							/>
						</label>
					</div>
					<div className="medium-12 cell">
						<label>
							URL
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].url}
								id={'sidefeaturedpost-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-url' }
								fullWidth={true}
								name="url"
							/>
						</label>
					</div>
                </div>
				<PromotionVariantActionsBottom
					periodKey={this.props.periodKey}
					variantKey={this.props.variantKey}
				/>

			</div>
		)
    }
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
};

export default connect(mapStateToProps)(PromotionVariantSideFeaturedPostComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/sideFeaturedPost.js